import { FC, memo } from 'react';

import { List, ListItem } from './bedroomFilters.styles';
import { useBedroomFilters } from './bedroomFilters.hook';
import { BedroomFiltersProps, BedroomFilterType } from './bedroomFilters.types';
import { Filter } from './filter';

type RenderBedroomFilterArgs = {
  filter: BedroomFilterType;
  onClick: () => void;
  key: number;
};

type RenderBedroomFilter = (args: RenderBedroomFilterArgs) => JSX.Element;

const renderBedroomFilter: RenderBedroomFilter = ({
  filter: { price, bedroom, checked },
  onClick,
  key,
}) => (
  <ListItem disableGutters key={key}>
    <Filter
      price={price}
      bedroom={bedroom}
      checked={checked}
      onClick={onClick}
    />
  </ListItem>
);

export const BedroomFilters: FC<BedroomFiltersProps> = memo(
  ({ listing, bedrooms, properties }) => {
    const { bedroomFilters, onBedroomFilterClick } = useBedroomFilters({
      listing,
      bedrooms,
      properties,
    });

    return (
      <List disablePadding>
        {bedroomFilters.map((filter, key) => {
          const { count } = filter;
          const onClick = () => onBedroomFilterClick(count);

          return renderBedroomFilter({ filter, onClick, key });
        })}
      </List>
    );
  }
);
